export default __webpack_public_path__ + "static/media/Doubly_List_Deletion_2.ba744dd0.gif";